import { View } from 'react-native'
import styled from 'styled-components'
import { media } from '@flix/common/style/media'

export const Container = styled(View)`
  min-height: 540px;
  max-width: ${(props) => props.maxWidth || 'auto'};
  align-items: center;
  padding: 0 ${(props) => props.theme.spacing.smedium}px;
  margin: ${(props) => props.theme.spacing.xlarge}px auto
    ${(props) => props.theme.spacing.xxlarge}px;
  ${media.sm`
    padding: 0;
  `}
`
